import tokenHttpClient from "../utils/httpClient";
import { postWithCSVResponse } from "../utils/httpClient-methods";
import { BASE_URL, API_URL } from "../utils/AppApiUrl";

export const DownloadAltAndLinkedSpareService = async (type, id) => {
  try {
    const param = {
      type,
      id,
    };
    const response = await postWithCSVResponse(
      tokenHttpClient,
      `${BASE_URL}${API_URL.downloadAlternateAndLinkedSpares}`,
      param
    );
    // add condition here to check
    if (response.status === 200) {
      return response;
    } else {
      return [];
    }
  } catch (err) {
    throw err;
  }
};
